import logo from './logo.svg';
import './App.css';
import axios from 'axios';

function App() {


  const loadRazorpayScript = async () => {
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.async = true;
    document.body.appendChild(script);
}



  const loadRazorpay = (orderData) => {
    const options = {
      key: "rzp_test_cX3TsUxGvlP7NP", // Replace with your Razorpay key ID
      amount: orderData.amount, // amount in the smallest currency unit
      currency: "INR",
      name: "Your Company Name",
      description: "Test Transaction",
      image: "https://your-logo-url.com/logo.png",
      order_id: orderData.id, // Razorpay order ID from backend
      handler: function (response) {
        alert(`Payment successful! Payment ID: ${response.razorpay_payment_id}`);
        // You can also send this response to your backend for verification
      },
      prefill: {
        name: "Your Name",
        email: "email@example.com",
        contact: "9999999999",
      },
      theme: {
        color: "#3399cc",
      },
    };
  
    const rzp = new window.Razorpay(options);
    rzp.open();
  };




  // const handlePayment = async () => {
  //   // await loadRazorpayScript(); 
  
  //   const res = await axios.post("https://api.razorpay.com/v1/orders", {
  //     amount: 500, // ₹500 (will be converted to 50000 paisa)
  //     currency: "INR",
  //     receipt: "receipt#1234"
  //   });
  //   const orderData = res.data;
  
  //   //const orderData = await res.json();
  //   console.log(orderData);
  //   //loadRazorpay(orderData);
  // };


  const handlePayment = async () => {
    await loadRazorpayScript(); // Load Razorpay script
  
    try {
      const res = await axios.post("https://nfcpayment.ishivax.com/create-order", {
        amount: 500,
        currency: "INR",
        receipt: "receipt#1234"
      });
  
      const orderData = res.data;
      console.log(orderData);
      loadRazorpay(orderData);
  
    } catch (error) {
      console.error("Axios error:", error.message);
      alert("Could not create order. Is your backend running?");
    }
  };
  const createOrderDto = {
    amount: 100000,
    currency: "INR",
    receipt: "Receipt no. 51",
    notes: {
      notes_key_1: "Tea, Earl Grey, Hot",
      notes_key_2: "Tea, Earl Grey… decaf."
    }
  };
  
  // Base64 string from Razorpay: username:password => btoa("rzp_live_XXXXX:XXXXX")
  //const authKeyBase64 = btoa("rzp_live_kSsZim6DiqXH5y:your_secret_here");

  const createOrder = async () => {
    try {
      const response = await fetch("https://api.razorpay.com/v1/orders", {
        method: "POST",
        headers: {
          "Authorization": `Basic cnpwX3Rlc3RfY1gzVHNVeEd2bFA3TlA6RjJGWDc0Skc0a1A3dlExQWNZS0M0aTRo`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify(createOrderDto)
      });
  
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
  
      const data = await response.json();
      console.log("Razorpay Order Response:", data);
      return data;
  
    } catch (error) {
      console.error("Error creating Razorpay order:", error);
      throw error;
    }
  };
  





  return (
    <div className="App">
      <header className="App-header">

      <h1>Scan NFC to Pay</h1>

<button type='submit' onClick={handlePayment}   >Pay Now</button>



      </header>
    </div>
  );
}

export default App;
